import {
  FilterTagProps,
  FilterTag,
  FilterDropdown,
} from 'modules/shared-components/filters';
import { Markets } from 'api/types/httpsTypes';

const marketOptions = [
  { label: 'SPOT', value: Markets.Spot },
  { label: 'FUTURES', value: Markets.Futures },
];

type MarketFilterProps = {
  value: string[];
  onChange: (value: string[]) => void;
};

export function MarketFilter({ value = [], onChange }: MarketFilterProps) {
  return (
    <FilterDropdown
      value={value}
      options={marketOptions}
      label="Market"
      onChange={onChange}
    />
  );
}

export function MarketFilterTag({
  value,
  ...rest
}: Omit<FilterTagProps, 'label'> & { value: string }) {
  const option = marketOptions.find((x) => x.value === value);
  return option ? <FilterTag {...rest} label={option.label} /> : null;
}
